import React from "react";

import { GridColumn } from "@progress/kendo-react-grid";
import { checkBoxCell, customCell, GridPanel, IRoutedTabProps } from "@selas/ui-components";
import { useTranslation } from "react-i18next";

import Endpoint from "../../../services/api/endpoint";
import { hasPermission } from "../../../services/authentication";
import { Permission } from "../../../utils/enums";
import TopicEditor from "../../editors/masterdata/topic";

const Topics: React.FC<IRoutedTabProps> = () => {
	const { t } = useTranslation();

	return (
		<GridPanel
			listEndpoint={Endpoint.TopicsList}
			endpoint={Endpoint.Topics}
			addScreen={{ screen: TopicEditor, isAllowed: hasPermission(Permission.TopicsAdd) }}
			editScreen={{ screen: TopicEditor, isAllowed: hasPermission(Permission.TopicsUpdate) }}
			delete={{ isAllowed: hasPermission(Permission.TopicsDelete) }}
			filter={{
				logic: "and",
				filters: [
					{
						field: "active",
						operator: "eq",
						value: true
					}
				]
			}}
		>
			<GridColumn field="name" title={t("name")} />
			<GridColumn field="active" title={t("active")} filter="boolean" width="160px" cell={customCell(checkBoxCell())} />
		</GridPanel>
	);
};

export default Topics;
